import { createContext } from "react";

export const ServiceProfile = createContext()